export type Coordinates = {
  latitude: number;
  longitude: number;
};

export type MoveCallbackParams = Coordinates & {
  distance: number;
};

export type MoveCallback = (params: MoveCallbackParams) => void;

export const toRadians = (degrees: number): number => degrees * (Math.PI / 180);

export const calculateDistance = (
  pos1: Coordinates,
  pos2: Coordinates,
): number => {
  const R = 6371000;
  const dLat = toRadians(pos2.latitude - pos1.latitude);
  const dLon = toRadians(pos2.longitude - pos1.longitude);

  const lat1 = toRadians(pos1.latitude);
  const lat2 = toRadians(pos2.latitude);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.sin(dLon / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
};
